import Header from "../sections/Header";
import Footer from "../sections/Footer";
import "../style/style.css";
import { PATHS } from "../utils";
import useKontentServiceApi from "../services/useKontentServiceApi";
import { useEffect } from "react";
import IndustryInfo from "../sections/IndustryInfo";
import {useParams, useNavigate} from "react-router-dom";


// const useQuery = () => {
//   return new URLSearchParams(useLocation().search);
// };
const IndustryInfoPage = () => {
  const {slug} = useParams<{slug: string}>();
  const navigate = useNavigate();
  // const query = useQuery();
  // const [code, setCode] = useState<string>("");
  // const validateURLParams = useCallback(
  //   (str: string) => {
  //     try {
  //       return atob(str);
  //     } catch (err) {
  //       navigate(PATHS.notFoundPage);
  //     }
  //   },
  //   [navigate]
  // );

  // const id = query.get("id") as string;
  // const decodedStr = validateURLParams(id) as string;
  // const slug = decodedStr
  //   ?.toString()
  //   ?.toLowerCase()
  //   ?.trim()
  //   .replace(/\s+/g, "_");

  const { data, errorCode, loading } = useKontentServiceApi(slug || "", true, "industry_content_info");

  useEffect(() => {
    if (slug && errorCode === 100) {
      navigate(PATHS.notFoundPage);
    }
  }, [slug, errorCode, navigate]);

  return (
    <>
      <Header loading={loading} />
      <IndustryInfo data={data} />
      <Footer />
    </>
  );
};

export default IndustryInfoPage;
